export default __webpack_public_path__ + "static/media/sircleBlueWithWhiteRingAndGreenBorder.de29253d.svg";